import type { TRouteObject } from "@ch/helpers/utils/types";
import ErrorPage from "@ch/pages/ErrorPage";
import NaviHealthPageLazy from "@ch/pages/NaviHealth";
import NotFoundPage from "@ch/pages/NotFoundPage";

const NaviHealthRoutes: TRouteObject[] = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <NaviHealthPageLazy />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
];

export default NaviHealthRoutes;
